// MUI ICON COMPONENTS

import { H2, H6, Span } from "src/lib/components/salify-next-layout/default/components/Typography";
import {
  FlexBetween,
  FlexBox,
} from "src/lib/components/salify-next-layout/default/components/flex-box";
import useSettings from "src/lib/components/salify-next-layout/default/hooks/useSettings";
import styled from "@mui/material/styles/styled";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import SalifyLink from "src/lib/components/link/salify-link";

// ===================================================

const SeeAllButton = styled(FlexBox)({
  alignItems: "center",
  gap: 4,
  border: "1px solid #E2E8EF",
  padding: "8px 16px",
  borderRadius: "100px",
  background: "#FFF",
  inlineSize: "max-content",
});

const SectionHeader = (props) => {
  const { title, subTitle, seeMoreLink, icon } = props;
  const { settings } = useSettings();
  return (
    <FlexBetween mb={3} gap={3}>
      <FlexBox alignItems="center" gap={1}>
        {icon ? <FlexBox alignItems="center">{icon}</FlexBox> : null}
        <FlexBox flexDirection="column" gap="2px">
          <H2 fontWeight="bold" lineHeight="1">
            {title}
          </H2>
          {subTitle && <H6 fontWeight={400}>{subTitle}</H6>}
        </FlexBox>
      </FlexBox>

      {seeMoreLink ? (
        <SalifyLink href={seeMoreLink}>
          <Span color={"green"}>
            <SalifyFallback.Label path="View All" default="Xem tất cả" />
          </Span>
        </SalifyLink>
      ) : null}
    </FlexBetween>
  );
};

export default SectionHeader;
